import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Clock } from "lucide-react";
import StatusBadge from "./StatusBadge";
import { relativeTime } from "@/lib/utils-app";

export default function CaseCard({ c }) {
  return (
    <Link
      to={`/cases/${c.case_id}`}
      data-testid={`case-card-${c.case_id}`}
      className="block group bg-white border border-zinc-200 rounded-sm p-5 transition-all duration-200 hover:border-blue-400 hover:-translate-y-[1px]"
    >
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500">
            {c.ref}
          </div>
          <h3 className="mt-1.5 text-lg font-medium text-zinc-900 group-hover:text-blue-700 transition-colors truncate">
            {c.title}
          </h3>
          {c.address && (
            <div className="mt-2 flex items-center gap-1.5 text-sm text-zinc-500">
              <MapPin className="w-3.5 h-3.5 stroke-[1.5]" />
              <span className="truncate">{c.address}</span>
            </div>
          )}
        </div>
        <StatusBadge status={c.status} />
      </div>
      <div className="mt-4 pt-4 border-t border-zinc-100 flex items-center justify-between text-xs text-zinc-500">
        <span className="font-medium text-zinc-700">{c.case_type}</span>
        <span className="flex items-center gap-1">
          <Clock className="w-3 h-3 stroke-[1.5]" /> {relativeTime(c.updated_at)}
        </span>
      </div>
    </Link>
  );
}
